import React from "react";
import PropTypes from 'prop-types';




class ChangingProgressProvider extends React.Component {
  static defaultProps = {
    interval: 900
  };

  state = {
    valuesIndex: 0
  };

  componentDidMount() {
    setInterval(() => {
      // This will hold the increment when pauseValue prop is matched.
      this.props.pauseValue !== this.props.values[this.state.valuesIndex]
        && this.setState({
          valuesIndex: (this.state.valuesIndex + 1) % this.props.values.length
        });
    }, this.props.interval);
  }

  render() {
    return this.props.children(this.props.values[this.state.valuesIndex]);
  }
}


ChangingProgressProvider.propTypes = {
  values: PropTypes.array.isRequired,
  pauseValue: PropTypes.number,
};

export default ChangingProgressProvider;
